import { gql } from '@apollo/client'

export interface IParkingPoolProfile {
  id: string
  name: string
  // S0407 (olivia-backend#2795): exactly one profile per pool carries this, and
  // the backend holds the invariant. Optional here only so the type stays usable
  // for selections that do not ask for it -- findDefaultProfile treats a missing
  // flag as "not the default", which is what an unfetched field means.
  isDefault?: boolean
  disabled?: boolean
  maxActiveUserCount?: number | null
  maxActiveUserCountUnlimited?: boolean | null
  maxAdvanceDays?: number | null
  maxAdvanceDaysUnlimited?: boolean | null
  maxDurationDays?: number | null
  maxDurationDaysUnlimited?: boolean | null
  maxReservationCountPerUser?: number | null
  maxReservationCountPerUserUnlimited?: boolean | null
  customEmailMessage?: string | null
  usersAggregate?: { count: number } | null
  parkings?: { parking?: { name: string } | null }[] | null
}

export interface IParkingPool {
  id: string
  showPlaceNames: boolean
  profiles: IParkingPoolProfile[]
  users: {
    login: string
  }[]
}

export interface IGetTenantParkingPoolUsersVars {
  tenant: string
}

export interface IGetTenantParkingPoolUsersData {
  getTenant: {
    parkingPool: IParkingPool
  }
}

export const GET_TENANT_PARKING_POOL_USERS = gql`
  query getTenant($tenant: String) {
    getTenant(name: $tenant) {
      parkingPool: parking_pool {
        id
        showPlaceNames: show_place_names
        profiles(filter: { not: { disabled: true } }) {
          id
          name
          isDefault: is_default
          disabled
          maxActiveUserCount: max_active_user_count
          maxActiveUserCountUnlimited: max_active_user_count_unlimited
          maxAdvanceDays: max_advance_days
          maxAdvanceDaysUnlimited: max_advance_days_unlimited
          maxDurationDays: max_duration_days
          maxDurationDaysUnlimited: max_duration_days_unlimited
          maxReservationCountPerUser: max_reservation_count_per_user
          maxReservationCountPerUserUnlimited: max_reservation_count_per_user_unlimited
          customEmailMessage: custom_email_message
          usersAggregate {
            count
          }
          parkings {
            parking {
              name
            }
          }
        }
        users {
          login
        }
      }
    }
  }
`
